module.exports = "/_next/static/images/game-header-target-82cd61165446b44f01d92ffd1c96c301.png";